
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DynamicFormEngine from '../dynamicFormEngine';
import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { bloqcibeApi, useGetTrialSiteInfoQuery } from '../../store/slices/apiSlice';
import { getUserRole } from '../util';

const ReadonlyFormDetails = (props) => {
    const { open, handleClose, title, step, trialId, sponsorId, trialSiteId } = props;
    const [formConfig, setFormConfig] = useState(null);
    const {user: loggedInUser, userData} = useSelector((state) => state.auth);
    const [getLibraryForm] = bloqcibeApi.endpoints.getLibraryForm.useLazyQuery();
    const { data: trialSiteinfo } = useGetTrialSiteInfoQuery({
        sponsorId: sponsorId,
        trialId: trialId,
        siteTrialId: trialSiteId,
    });
    const enrolmentDocumentKey = useSelector((state) => state?.trial?.trialSiteDetail?.siteTrialData?.trial?.eConsentForm);

    const userSiteTrialRole = useMemo(() => {
      return getUserRole(loggedInUser, trialId, trialSiteinfo?.siteTrialData?.site?.id, userData);
    }, [loggedInUser, trialSiteinfo, userData]);

    useEffect(() => {
      (async () => {
        if (step && enrolmentDocumentKey) {
          const formDetailsData = await getLibraryForm(
            `${process.env.REACT_APP_API_ENDPOINT_URL}form-library/library/bloqcube/${enrolmentDocumentKey}`
        //   `http://localhost:3003/form-library/library/bloqcube/${enrolmentDocumentKey}`
          );
          if (formDetailsData.data) {
            setFormConfig(formDetailsData.data.steps.find((_obj) => _obj.key === step));
          } else if (formDetailsData.error) {
            console.error('UNABLE TO GET FORM DETAILS');
          }
        }
      })();
    }, [step, enrolmentDocumentKey]);

    return (
        <Dialog
            scroll={"paper"}
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>
                {title}
            </DialogTitle>
            <DialogContent>
                <DynamicFormEngine
                    formConfig={formConfig}
                    userSiteTrialRole={userSiteTrialRole}
                    showSkeleton={true}
                    hideTab
                />
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )

}

export default ReadonlyFormDetails;